import { ChatNav } from './model/chat-nav.model';

export interface ChatMenuDialogState {
    nav: ChatNav;
    ctx?: any;
    minimized?: boolean;
}

export const defaultState = (): ChatMenuDialogState => ({
    nav: ChatNav.MENU,
});
